<template>
  <slot name="header_close" />
  <div
    :class="[
      {
        'number-add-second-frame': isIndepend,
        'number-false': !settings.isValidNumber,
      },
    ]"
  >
    <div class="title">
      <span>{{ $t("dialog.add_number.title_modal") }} Whatsapp</span>
    </div>
    <slot name="actions" />
    <form class="content" @submit.prevent="confirmDialog">
      <integration-select
        parentClass="number-add-second-frame"
        :options="selectedOptions"
        filter="whatsapp"
        readonly
      />
      <PhoneInput v-model:userNumber="newNumber" />
      <ButtonConfirm class="submit_btn" type="submit">
        {{ $t("dialog.add_number.button") }}
      </ButtonConfirm>
    </form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import IntegrationSelect from "../../Recurring/IntegrationSelect.vue";
import ButtonConfirm from "../../Recurring/ButtonConfirm.vue";
import PhoneInput from "../../Recurring/PhoneInput.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
// import useActivationWhatsapp from "@/components/activation/api/useActivationWhatsapp";

const router = useRouter();
const { t: $t } = useI18n();
const store = useStore();

const newNumber = ref("");
const settings = reactive({
  isValidNumber: true,
});
const selectedOptions = ref({
  title: true,
});

defineProps({
  isIndepend: {
    type: Boolean,
    default: true,
  },
});

const confirmDialog = async () => {
  //   const { addNumber } = useActivationWhatsapp();
  const isValidNumber =
    newNumber.value.length <= 13 && newNumber.value.length > 9;

  if (isValidNumber) {
    store.commit("closeDialog");

    store.commit("activation/SET_NUMBER", newNumber.value);
    store.commit("activation/SET_MESSENGER", "whatsapp");

    const goToActivation = await store.dispatch("activation/addNumber");

    goToActivation &&
      router.push({
        name: "ActivationWhatsapp",
        params: { number: newNumber.value },
      });
  } else {
    settings.isValidNumber = isValidNumber;
  }
};
onMounted(() => {
  store.commit("activation/CLEAR_STATE");
});
</script>
<!-- wasn't scoped in style -->
<style lang="scss" scoped>
// !TODO: REFACTOR
.number-false {
  label {
    // background-color: black;
  }
}

.number-add-second-frame {
  padding: 20px 28px 42px;
  max-width: 750px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  // height: calc(100vh - 80px);
  box-sizing: border-box;
  border-radius: 7px;
  background-color: white;
  text-align: center;
}

.title {
  text-align: center;
  font-family: Gilroy;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--text-color);

  span {
    font-size: 20px;
  }
}

.content {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 1;
  justify-content: flex-end;
  text-align: left;
}

.submit_btn {
  margin: 0 auto;
}
</style>
